import { motion } from "framer-motion";

export const SectionHeading = ({ index, title, sub }) => (
  <div className="mb-14 md:mb-20">
    <motion.span
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="block text-xs uppercase tracking-[0.35em] text-zinc-500 mb-4"
    >
      {index} / {sub}
    </motion.span>
    <div className="overflow-hidden">
      <motion.h2
        initial={{ opacity: 0, y: 48 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="font-display tracking-tight leading-none text-5xl md:text-7xl"
      >
        {title}
      </motion.h2>
    </div>
  </div>
);
